import React from 'react';
 
function FixedPanel({children}) {
   return <div className="fixedPanel">{children}</div>
}
 
export default FixedPanel;